import { render, staticRenderFns } from "./ConsignorInformationForm.vue?vue&type=template&id=6a4e077b"
import script from "./ConsignorInformationForm.vue?vue&type=script&lang=js"
export * from "./ConsignorInformationForm.vue?vue&type=script&lang=js"
import style0 from "./ConsignorInformationForm.vue?vue&type=style&index=0&id=6a4e077b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports